import React from "react";
import { I18n } from "react-redux-i18n";

import { EmailAndRemindersProps } from "./email-and-reminders.types";

export const useEmailAndRemindersController = (props: EmailAndRemindersProps) => {
  const { getEmailTemplates, showErrorMessage } = props;

  const [emailTemplates, setEmailTemplates] = React.useState<Array<{ value: number; label: string }>>([]);

  const handleGetEmailTemplates = React.useCallback(() => {
    getEmailTemplates()
      .then((res) => {
        setEmailTemplates(res.map((x) => ({ value: x.id, label: x.name })));
      })
      .catch((err) => {
        console.error(err);
        showErrorMessage(err?.entity || I18n.t("Failed to get email templates"));
      });
  }, [getEmailTemplates, showErrorMessage]);

  const initialize = React.useCallback(async () => {
    handleGetEmailTemplates();
  }, [handleGetEmailTemplates]);

  React.useEffect(() => {
    initialize();
  }, []);

  return {
    emailTemplates,
  };
};
